export default function (value) {
  const valueLengthMax = 30

  return value.length > valueLengthMax
    ? value.substring(0, valueLengthMax - 3) + '...'
    : value
}
